import React, { useContext } from 'react';

import { ApiContext } from 'Services/api-context';
import { ServiceProviderProps } from './common';
import { SettingsServiceApiContext, ISettingsServiceApi } from 'Services/settings-service/settings-service';

export const SettingsServiceApiProvider: React.FC<ServiceProviderProps<ISettingsServiceApi>> = ( props, context ) => {
  const api = useContext( ApiContext );
  const settingsServiceApi: ISettingsServiceApi = new props.useClass( api );

  return (
    <SettingsServiceApiContext.Provider value={ settingsServiceApi }>
      { props.children }
    </SettingsServiceApiContext.Provider>
  );
};
